import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'

const InfoPlaceLockPopup = ({ cancelAction, body }) => {
  const { t } = useTranslation('basket')
  const { goBack } = useHistory()

  return (
    <Popup close={cancelAction || goBack}>
      <div className='popup__title'>
      <div>{t('howToOpenTheYard')}</div>
      </div>
      <div className='popup__infoBlocks'>
        <span className='desc'>{t('selectHowYouWouldLikeToOpen')} <span>{t('yardGate')}</span>. {t('youCanChooseSeveralOfTheAvailableOptions')}</span>
        <h2>{t('howDoesItWork')}</h2>
        {body?.gate?.openingMethods?.map((method) => {
          return (
            <div key={method.id} className={`lockItem lockItem--info`}>
              <div><i className='icon icon--byapp'></i>{method.name} </div>
              <div>{method.howToForClient}</div>
            </div>
          )
        })}
        <ArrowBtn
          enlarged
          showArrow={false}
          text={t('gotIt')}
          action={cancelAction || goBack} />
      </div>
    </Popup>
  )
}

export default InfoPlaceLockPopup